export const PRINCIPAL_VENDOR = 'Principal'
export const OTHER_VENDOR = 'Distributor,Marketplace'
